import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DialogConfigInterface} from '@shared/model';
import {DialogHelper} from '@shared/helper/dialog.helper';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  dialogConfigs$: BehaviorSubject<DialogConfigInterface[]> = new BehaviorSubject<DialogConfigInterface[]>([]);

  addDialog(index: string, title?: string, top?: string, left?: string): void {
    const configs = this.dialogConfigs$.getValue();
    configs.push(DialogHelper.getHideDialogConfig(index, title, top, left));
    this.dialogConfigs$.next(configs);
  }

  toggleShow(index: string, show: boolean, fixed: boolean = false) {
    const configs = this.dialogConfigs$.getValue();
    const find = configs.find((c: DialogConfigInterface) => c.id === index);
    if (find) {
      find.show = show;
      this.dialogConfigs$.next(configs);
    }
  }

  setFirst(id: string) {
    this.dialogConfigs$.next(this.dialogConfigs$.getValue());
  }

  updateTitle(id: string, title: string) {
    let configs = this.dialogConfigs$.getValue();
    configs.forEach((c: DialogConfigInterface) => {
      c.title = (c.id === id) ? title : c.title;
    });
    this.dialogConfigs$.next(configs);
  }
}
